import { App } from 'vue'
import PrimeVue from 'primevue/config'

export default {
  install(app: App<Element>) {
    app.use(PrimeVue, {
    })
  }
}